module.exports = "/365FarmNet/dist/dashboard.a5830262be42459d5d6d7861e83d3700.html";